import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchExemptionManagementList = () => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': '/vehicles/exemption',
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_EXEMPTION_MANAGEMENT_LIST,
        ActionTypes.FETCHED_EXEMPTION_MANAGEMENT_LIST,
        [
          ActionTypes.FETCHED_EXEMPTION_MANAGEMENT_LIST_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const fetchExemptionManagementInfo = (id) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/vehicles/exemption/${id}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_EXEMPTION_MANAGEMENT_INFO,
        ActionTypes.FETCHED_EXEMPTION_MANAGEMENT_INFO,
        [
          ActionTypes.FETCHED_EXEMPTION_MANAGEMENT_INFO_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const addExemptionManagement =
  (data = {}) =>
    (dispatch) => {
      return dispatch(
        apiActionCreator({
          'endpoint': '/vehicles/exemption',
          'authenticated': true,
          'types': [
            ActionTypes.ADDING_EXEMPTION_MANAGEMENT_INFO,
            [
              ActionTypes.ADDED_EXEMPTION_MANAGEMENT_INFO,
              MessageActions.addMessageBoxInfo(
                'Rango de exoneración creado satisfactoriamente'
              ),
            ],
            [
              ActionTypes.ADDED_EXEMPTION_MANAGEMENT_INFO_FAILED,
              (error) => buildErrorMessage(error),
            ],
          ],
          'microservice': 'part',
          'method': 'POST',
          'contentType': 'application/json',
          'data': data,
        })
      );
    };

export const updateExemptionManagement =
  (id, data = {}) =>
    (dispatch) => {
      return dispatch(
        apiActionCreator({
          'endpoint': `/vehicles/exemption/${id}`,
          'authenticated': true,
          'types': [
            ActionTypes.UPDATING_EXEMPTION_MANAGEMENT_INFO,
            [
              ActionTypes.UPDATED_EXEMPTION_MANAGEMENT_INFO,
              MessageActions.addMessageBoxInfo(
                'Rango de exoneración actualizado satisfactoriamente'
              ),
            ],
            [
              ActionTypes.UPDATED_EXEMPTION_MANAGEMENT_INFO_FAILED,
              (error) => buildErrorMessage(error),
            ],
          ],
          'microservice': 'part',
          'method': 'PUT',
          'contentType': 'application/json',
          'data': data,
        })
      );
    };

export const deleteExemptionManagement = (id) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/vehicles/exemption/${id}`,
      'authenticated': true,
      'types': [
        ActionTypes.DELETING_EXEMPTION_MANAGEMENT_INFO,
        [
          ActionTypes.DELETED_EXEMPTION_MANAGEMENT_INFO,
          MessageActions.addMessageBoxInfo(
            'Rango de exoneración eliminado satisfactoriamente'
          ),
        ],
        [
          ActionTypes.DELETED_EXEMPTION_MANAGEMENT_INFO_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'part',
      'method': 'DELETE',
    })
  );
};

export const clearExemptionForm = () => ({
  'type': ActionTypes.CLEAR_EXEMPTION_MANAGEMENT_INFO,
});

export const setDisabilityValueFrom = (name, value, id) => ({
  'type': ActionTypes.SET_DISABILITY_VALUE_FROM,
  'payload': {name, value, id},
});
